import {
  AddLoginMethod,
  LoginMethodId,
  LoginRedirectRequest,
  RequestLoginReset,
  ResetLoginMethodResponse,
  UpdateLoginMethodRequest,
  UpdateLoginMethodResponse,
} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";
import {rewritingLoginCookie} from "./auth";

export async function get() {
  return await platformedClient.internalRequest("get", "/api/login/method", {});
}

export async function set(LoginMethodId: LoginMethodId) {
  const res = await platformedClient.internalRequest("post", "/api/login/method", {body: LoginMethodId});
  await invalidateQueries([q.accountUsers.filter(), q.user.filter(), q.whoAmI.filter(), q.userLoginMethod.filter()]);
  return res;
}

export async function validateInviteToken(token: string) {
  return await platformedClient.internalRequest("get", "/api/login/invite", {
    header: {Authorization: `Bearer ${token}`},
    skipErrorHandler: true,
  });
}

export async function validateResetToken(token: string) {
  return await platformedClient.internalRequest("get", "/api/login/reset", {
    header: {Authorization: `Bearer ${token}`},
    skipErrorHandler: true,
  });
}

export async function reset(
  token: string,
  loginMethodId: LoginMethodId,
  payload: AddLoginMethod,
): Promise<ResetLoginMethodResponse> {
  return await rewritingLoginCookie(() =>
    platformedClient.internalRequest("post", "/api/login/methods/{login_method_id}/reset", {
      path: {login_method_id: loginMethodId},
      body: payload,
      header: {Authorization: `Bearer ${token}`},
    }),
  );
}

export async function validatePasswordComplexity(token: string, password: string): Promise<void> {
  await platformedClient.internalRequest("post", "/api/login/validate_password_complexity", {
    body: password,
    header: {Authorization: `Bearer ${token}`},
    skipErrorHandler: true,
  });
}

export async function requestReset(requestLoginReset: RequestLoginReset) {
  return await platformedClient.internalRequest("post", "/api/login/request_reset", {body: requestLoginReset});
}

export async function upsert(
  loginMethodId: LoginMethodId,
  payload: UpdateLoginMethodRequest,
): Promise<UpdateLoginMethodResponse> {
  const res = await rewritingLoginCookie(() =>
    platformedClient.internalRequest("post", "/api/login/methods/{login_method_id}/update", {
      path: {login_method_id: loginMethodId},
      body: payload,
    }),
  );
  await invalidateQueries([q.userLoginMethod.filter(), q.userLoginMethods.filter()]);
  return res;
}

export async function delete_(loginMethodId: LoginMethodId) {
  const res = await platformedClient.internalRequest("delete", "/api/login/methods/{login_method_id}", {
    path: {login_method_id: loginMethodId},
  });
  await invalidateQueries([q.userLoginMethod.filter(), q.userLoginMethods.filter()]);
  return res;
}

export async function requestRedirectUrl(loginMethodId: LoginMethodId, req: LoginRedirectRequest) {
  const res = await platformedClient.internalRequest("post", "/api/login/methods/{login_method_id}/redirect", {
    path: {login_method_id: loginMethodId},
    body: req,
  });
  return res;
}

export async function list() {
  return await platformedClient.internalRequest("get", "/api/login/methods", {});
}
